import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import { replaceFile } from "../api/insuranceVerificationApi";
import { insuranceVerificationKeys } from "../api/insuranceVerificationKeys";
import { companyDocumentKeys } from "newui/features/Company/CompanyDocuments/companyDocumentKeys";

export const useReplaceFile = (documentId: number) => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation({
    mutationFn: (formData: FormData) =>
      replaceFile(companyId as number, documentId, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.documents(companyId as number),
      });
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.usage(companyId as number),
      });
      queryClient.invalidateQueries({
        queryKey: companyDocumentKeys.documents(companyId as number),
      });
    },
  });
};
